import React from 'react';

function Cursos(props) {
    var cursos = [];
    props.cursos?.forEach(curso => {
        cursos.push(
            <div className="accordion-item" key={curso?.id}>
                <h2 className="accordion-header p-2">
                    <button className="accordion-button bg-orange text-white" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse" + curso.id} aria-controls={"collapse" + curso.id}>
                        {curso?.attributes.nombre}
                    </button>
                </h2>
                <div id={"collapse" + curso?.id} className="accordion-collapse collapse" data-bs-parent="#accordionCursos">
                    <div className="accordion-body">
                        <div className='row'>
                            <div className='col-12 col-md-7'>
                                <img className="img-fluid" src={process.env.REACT_APP_API_URL + curso?.attributes.imagen.data.attributes.url} alt={curso.attributes.nombre} />
                            </div>
                            <div className='col-12 col-md-5 text-start'>
                                <p><strong>Duración:</strong> {curso?.attributes.duracion} horas</p>
                                <p><strong>Objetivo:</strong> {curso?.attributes.objetivo}</p>
                                <p>
                                    <strong>Temario:</strong><br />{curso?.attributes.temario.split('\n').map((line, index) => (
                                        <React.Fragment key={index}>
                                            {line}
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    });
    return (
        <React.Fragment>
            <div className="accordion" id="accordionCursos">
                {cursos}
            </div>
        </React.Fragment>
    );
}

export default Cursos;